<template>
  <VModal
      :title="product.name ? 'ویرایش محصول ' + product.name : 'ایجاد محصول'"
      :show="show">

    <VAlert class="mt-4" type="danger" v-if="errors.length > 0">
      <div v-for="(error, index) in errors"
           :key="error" :class="{'font-bold' : index === 0}">
        {{ index !== 0 ? '- ' + error : error }}
      </div>
    </VAlert>

    <form @submit.prevent="submit" ref="form">
      <input type="hidden" name="type" :value="$route.params.type">
      <input type="hidden" name="_method" value="PUT" v-if="product.name">

      <div class="mt-5">
        <VImageInput :photo="product.photo ? product.photo.path : ''"/>
      </div>

      <fieldset class="border rounded p-4 mt-4 pt-0">
        <legend>نام محصول</legend>

        <div v-for="lang in languages" :key="lang.id" class="mt-4">
          <label>نام {{ lang.name }}</label>
          <VInput
              type="text"
              :name="'name_' + lang.code"
              :value="$helper.getTextValue(lang, product.name_text)"
              placeholder="نام"
              class="mt-4"
              :disabled="user.role.type !== 'admin'"
              :required="lang.code === 'fa'"/>
        </div>
      </fieldset>

      <div class="mt-5">
        <label>قیمت</label>
        <VInput type="number" name="price" :value="product.price" placeholder="قیمت محصول"
                class="mt-4" :disabled="user.role.type !== 'admin'" required/>
      </div>

      <fieldset class="border rounded p-4 mt-4 pt-0">
        <legend>توضیحات محصول</legend>

        <div v-for="lang in languages" :key="lang.id" class="mt-4">
          <label>توضیحات {{ lang.name }}</label>
          <VInput
              type="text"
              :name="'description_' + lang.code"
              :value="$helper.getTextValue(lang, product.description_text)"
              placeholder="توضیحات"
              class="mt-4"
              :disabled="user.role.type !== 'admin'"
              :required="lang.code === 'fa'"/>
        </div>
      </fieldset>

      <div class="flex justify-between mt-5">
        <div>
          <label>دسته بندی</label>
          <select name="category_id" class="bg-dark-form rounded-lg w-full mt-4 p-3 " :disabled="user.role.type !== 'admin'">
            <option value="" disabled>انتخاب دسته بندی</option>
            <option v-for="category in categories"
                    :key="category.id"
                    :value="category.id"
                    :selected="product.category ? product.category.id === category.id : false">
              {{ category.name }}
            </option>
          </select>
        </div>
        <div>
          <label>موجودی</label>
          <VInput type="number" name="inventory" :value="product.inventory" placeholder="موجودی محصول" class="mt-4" required/>
        </div>
      </div>

      <div class="mt-5">
        <label>ترتیب</label>
        <VInput type="number" name="order" :value="product.order" placeholder="ترتیب نمایش محصول"
                class="mt-4" :disabled="user.role.type !== 'admin'" required/>
      </div>

      <div class="flex items-center justify-between mt-8">
        <div>
          <label>وضعیت محصول</label>
          <h6 class="mt-1 text-sm text-muted">در صورت غیرفعال بودن محصول، محصول نمایش داده نمیشود</h6>
        </div>

        <VSwitch v-model="active" :value="product.active"/>
      </div>

      <div class="flex items-center justify-between mt-8">
        <label>نمایش در صفحه اصلی</label>

        <VSwitch v-model="homepage" :value="product.homepage"/>
      </div>

      <VButton type="submit" class="mt-10 w-full">ثبت</VButton>

      <VLoadingScreen :show="loading"/>
    </form>

  </VModal>
</template>

<script>
import VModal from "@/components/General/VModal";
import VInput from "@/components/General/VInput";
import VSwitch from "@/components/General/VSwitch";
import VButton from "@/components/General/VButton";
import VImageInput from "@/components/General/VImageInput";
import {createProduct, updateProduct} from "@/API/API";
import VAlert from "@/components/General/VAlert";
import VLoadingScreen from "@/components/General/VLoadingScreen";
import {mapState} from "vuex";

export default {
  name: "ModalProduct",
  components: {VLoadingScreen, VAlert, VImageInput, VButton, VSwitch, VInput, VModal},
  emits: ['created', 'edited'],
  props: {
    show: Boolean,
    product: {
      type: Object,
      default: () => ({})
    },
    categories: Array
  },
  data() {
    return {
      image: '',
      active: 1,
      loading: false,
      errors: [],
      homepage: 0,
    }
  },
  computed: {
    ...mapState(['user', 'languages'])
  },
  methods: {
    submit() {
      this.loading = true
      this.errors = []

      let product = new FormData(this.$refs.form)
      product.append('active', this.active)
      product.append('homepage', this.homepage)

      if (this.product.name) {
        this.updateProduct(product)
      } else {
        this.createProduct(product)
      }
    },
    updateProduct(product) {
      updateProduct(this.product.id, product)
          .then(resp => {
            this.$emit('edited', resp.data)
          })
          .catch(err => {
            this.$helper.validationError(err, this.errors);
          })
          .finally(() => {
            this.loading = false
          })
    },
    createProduct(product) {
      createProduct(product)
          .then(resp => {
            this.$emit('created', resp.data)
          })
          .catch(err => {
            this.$helper.validationError(err, this.errors);
          })
          .finally(() => {
            this.loading = false
          })
    }
  }

}
</script>

<style scoped>

</style>